export default {"src":"/_next/static/media/ai.2a40f73a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};